import { useSelector } from 'react-redux';
import { useRef, useEffect } from 'react';
import './style.scss';

const AutoHeader = (props) => {
  const { text } = props;
  const step = useSelector((state) => state.app.currentStep);
  const firstRun = useSelector((state) => state.app.firstRun);
  const focusRef = useRef(null);

  useEffect(() => {
    // don't focus if we have just launched the app
    if (!firstRun && focusRef.current) {
      focusRef.current.focus();
    }
  }, [focusRef, step, firstRun]);


  return (
      <>
      <h2 tabIndex="-1" ref={focusRef}>{text}</h2>
      <div class="fields-required">All fields required</div>
      </>
  );
};

export default AutoHeader;
